import {createRouter, createWebHistory} from "vue-router";
import planningRoutes from "./planning/router-planning.js";
import message from "@/router/private/message";
import externalLink from "@/router/public/externalLink";
import registration from "@/router/public/registration";
import emailCheck from "@/router/public/emailCheck";
import password from "@/router/public/password";
import error from "@/router/public/error";
import login from "@/router/public/login";
import presentation from "@/router/public/presentation";
import candidacy from "@/router/private/candidacy";
import test from "@/router/private/test";
import dashboard from "@/router/private/dashboard";
import profil from "@/router/private/profil";

const routes = presentation
    .concat(emailCheck)
    .concat(registration)
    .concat(password)
    .concat(message)
    .concat(error)
    .concat(login)
    .concat(externalLink)
    .concat(planningRoutes)
    .concat(candidacy)
    .concat(dashboard)
    .concat(profil)
    .concat(test)
;

const router = createRouter({
    history: createWebHistory(process.env.VUE_APP_BASE_URL),
    routes: routes,
    scrollBehavior() {
        return {top: 0};
    }
});

router.onError((error) => {
    if (error.name === 'ChunkLoadError' || error.message.includes('Loading chunk') || error.message.includes('Loading CSS chunk')) {
        const chunkErrorKey = 'last-chunk-error-reload';
        const now = Date.now();
        const lastReload = sessionStorage.getItem(chunkErrorKey);

        // Empêcher de recharger plus d'une fois toutes les 10 secondes pour éviter les boucles infinies
        if (!lastReload || now - parseInt(lastReload) > 10000) {
            sessionStorage.setItem(chunkErrorKey, now.toString());
            window.location.reload();
        }
    }
});

router.beforeEach((to, from, next) => {

    const planning = to.name && (to.name.toLowerCase().startsWith("planning") || to.name.toLowerCase().startsWith("meeting"));

    // Appliquer le fond blanc pour les routes de planning
    if (planning) {
        document.body.classList.add('planning-body');
    } else {
        document.body.classList.remove('planning-body');
    }

    if (planning) {
        next();
        return;
    }

    const publicPages = to.name && to.name.startsWith("public-");
    const authRequired = !publicPages && !planning;
    const loggedIn = localStorage.getItem("user");
    if (publicPages && loggedIn) {
        // next({ name: "dashboard" });
        next();
    } else if (authRequired && !loggedIn) {
        next({name: "public-login"});
    } else {
        next();
    }

});

export default router;
